import { GzEasmVulnerabilitiesPerWeekWebComponent } from './component/GzEasmVulnerabilitiesPerWeekWebComponent';

export { GzEasmVulnerabilitiesPerWeekWebComponent };
